module.exports = "/src/views/player/lc/capture/citymap.jpg";